import { LogOut } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';
import EchoHireLogo from '@/components/branding/EchoHireLogo';
import ThemeToggle from '@/components/ThemeToggle';
import { Button } from '@/components/ui/button';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { useLogoutConfirm } from '@/components/ux/useLogoutConfirm';

export default function CandidateShell({ children }) {
  const { user } = useAuth();
  const { requestLogout, LogoutConfirmDialog } = useLogoutConfirm();

  const initials =
    user?.firstName?.[0]?.toUpperCase() ||
    user?.email?.[0]?.toUpperCase() ||
    'E';

  return (
    <div className="flex min-h-screen flex-col bg-background">
      {LogoutConfirmDialog}
      <header className="sticky top-0 z-30 border-b border-border bg-card/95 backdrop-blur-sm">
        <div className="flex h-12 w-full items-center justify-between gap-3 px-3 sm:px-5 lg:px-6">
          <EchoHireLogo size="compact" />
          <div className="flex items-center gap-1.5 sm:gap-2">
            <div className="hidden items-center gap-2 rounded-md border border-border/80 bg-muted/40 px-2.5 py-1 sm:flex">
              <Avatar className="h-7 w-7">
                <AvatarFallback className="bg-primary text-[10px] font-semibold text-primary-foreground">
                  {initials}
                </AvatarFallback>
              </Avatar>
              <span className="max-w-[10rem] truncate text-sm font-medium">
                {user?.firstName || user?.email || 'Candidate'}
              </span>
            </div>
            <ThemeToggle size="small" />
            <Button
              variant="ghost"
              size="icon"
              className="h-8 w-8 text-muted-foreground hover:text-destructive"
              onClick={requestLogout}
              aria-label="Log out"
            >
              <LogOut className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </header>
      <main className="w-full flex-1 px-3 py-4 sm:px-5 sm:py-5 lg:px-6">{children}</main>
    </div>
  );
}
